import { Component, OnInit } from '@angular/core';
import { AuthorizeService } from '../authorize.service';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import { BrandPickerComponent } from '../../app/shared/components/modals/brand-picker-modal/brand-picker.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-login-menu',
  templateUrl: './login-menu.component.html',
  styleUrls: ['./login-menu.component.css']
})

export class LoginMenuComponent implements OnInit {
  public isAuthenticated: Observable<boolean>;
  public userName: Observable<string>;

  constructor(private authorizeService: AuthorizeService, private modalService: NgbModal) { }

  ngOnInit() {
    this.isAuthenticated = this.authorizeService.isAuthenticated();
    this.userName = this.authorizeService.getUser().pipe(map(u => u && u.name));
  } 

  openBrandPicker(): void {   
      const modalRef = this.modalService.open(BrandPickerComponent);
      modalRef.componentInstance.title = 'Choose a Brand';  
  } 
}
